import React from 'react';
import { FieldErrorProps } from '@rjsf/utils';
/**
 * Why is this Template required?
 * This template is used for Global error handling in the react JSON form.
 * We are overrriding this Template and returning nothing since errors  are handled in the KatalComponents directly.
 *
 * This Template can be still used for debugging errors during new tenant onboarding.
 *
 * @param props
 * @returns null
 */
const FieldErrorTemplate = (props: FieldErrorProps) => {
  return null;
};

export default FieldErrorTemplate;
